import React from 'react'
import StudentInfoTD from './StudentTable/StudentInfoTd';
import ClassInfoTD from './StudentTable/ClassInfoTd';
import ClassStatusTD from './StudentTable/ClassStatusTd';
// import PaymentTD from './StudentTable/PaymentTd';
import locale from './locale';
import { SHOW_CLASSES_UPTO_NUMBER_OF } from './constants';
import CreateClassModal from 'template/Modals/CreateClass'
import CreateClassOneModal from 'template/Modals/CreateClassOne'
import isEmpty from 'lodash/isEmpty'
import Tooltip from 'react-tooltip';

// IMPORTANT NOTE:
// This function is bind to a Tab component.
// 'this' here refers to Tab Component
export default function(studentState) {

  if (studentState == "archived") {
    return getArchivedStudentFields.call(this);
  }

  return getDefaultFields.call(this);

}

function getDefaultFields() {
  let TabComponent = this;

  // default settings
  return [
    {
      name: "sName",
      title: __('Student', 'student', null, true),
      getTdProps: ({tbodyData})=>{
        return {
          className: "student-info",
          style: {
          }
        }
      },
      getTdContent: ({ trData: student })=>{
        return <StudentInfoTD studentInfo={student} />
      },
    },
    {
      name: "balance",
      title: __('Credit', locale),
      getTdContent: ({ trData: student, trIndex })=>{
        if (trIndex === 0) {
          return <div className='balance'>{student.balance + ' ' + student.currency}</div>
        } else {
          return '';
        }
      },
    },
    {
      name: "className",
      title: __('Class', 'student', null, true),
      getTdProps: ({tbodyData})=>{
        return {
          className: "class-info",
          style: {
            width: "28%"
          }
        }
      },
      getTdContent: (opts)=>{
        let {
          trData,
          tbodyData,
          trIndex: classIndex,
        } = opts;

        let {
          studentState,
        } = this.props;

        // student is the first item of tbodyData array
        let student = tbodyData[0];

        /**
         *
         * When there are 3 <tr> within this <tbody>
         * Which means there already 3 classes displayed,
         * We will collapse the rest of <tr> (classes)
         * right below the last row we leave a button to
         * expand these collapsed classes.
         *
         * Inside DefaultTab.js the method collapseRows() is then passed to the <Table />
         * through a prop called trFilter. This method filters out the classes.
         *
         */
        const numberOfClasses = tbodyData.length;

        const showExpandedButton = (classIndex + 1) == SHOW_CLASSES_UPTO_NUMBER_OF;

        const shouldExpand = numberOfClasses > SHOW_CLASSES_UPTO_NUMBER_OF;

        const expanded = this.isClassInfosExpanded(student);

        const TD = (
          <ClassInfoTD
            userId={this.props.user.result.user_id}
            classInfo={trData.classInfo}
            student={student}
            exitClass={this.exitClass}
            enrollStudentToClass={()=>{
              this.enrollStudentToClass([student], ()=>{
                this.props.student.fetchStudent('after enrolled at a class @classInfoTD', studentState);
              });
            }}
          />
        );

        return (
          <div>
            {TD}
            {
            shouldExpand && showExpandedButton && !expanded && (
              <div className='expand-folded-classes-button' onClick={()=>{
                  this.expandClassInfos(student);
                }}>
                <i className='fa icon-ellipsis'></i>
                <div className='button-text'>{__('show all ({classNumber})', 'student', { classNumber: numberOfClasses })}</div>
              </div>
              )
            }
          </div>
        );

        return TD;
      },
    },
    {
      name: "classStatus",
      title: __('Used/Purchased', locale),
      getTdContent: ({ trData: data })=>{
        return <ClassStatusTD classInfo={data.classInfo}/>;
      },
    },
    {
      name: 'tuitionConsumption',
      title: __('Used/Paid', locale),
      getTdContent: ({ trData: data })=>{
        const {currency} = this.props.schoolDetail.detail
        let {studentState} = this.props;
        const id = 'student-id-' + data.schoolStudentID;
 
        if (data.classInfo && data.classInfo.tuition_consumption !== null){
          if(data.classInfo.total_discount_amount > 0){
            return (
              <div>
                <span className={data.classInfo.tuition_consumption > data.classInfo.paidTotalFee ? 'notice-alert' : ''}>{data.classInfo.tuition_consumption + ' / ' + data.classInfo.paidTotalFee + ' ' +  currency}</span>
                <i className='fa icon-tag' data-tip data-for={id}></i>
                <Tooltip
                  id={id}
                  effect='solid'
                  place='bottom'
                  type='info'
                  getContent={()=> { return __('Discounted', locale) + ' ' + data.classInfo.total_discount_amount + ' ' + currency; }}
                />
              </div>
            )
          } else {
            return(
              <div className={data.classInfo.tuition_consumption > data.classInfo.paidTotalFee ? 'notice-alert' : ''}>
                {data.classInfo.tuition_consumption + ' / ' + data.classInfo.paidTotalFee + ' ' +  currency}
              </div>
            )
          }
        } else if (isEmpty(data.list)) {
          return (<div />)
        } else {
          return (<div style={{cursor: 'pointer'}} onClick={() => {
            if(data.classInfo.type == 0){
              CreateClassModal({mode: 'update', id: data.classInfo.classID})
              .then(() => {
                this.props.student.fetchStudent('after enrolled at a class @classInfoTD', studentState);
              })
            } else {
              CreateClassOneModal({mode: 'update', id: data.classInfo.classID})
              .then(() => {
                this.props.student.fetchStudent('after enrolled at a class @classInfoTD', studentState);
              })
            }
          }}>{__('Setup', locale) + ' / ' + data.classInfo.paidTotalFee + ' ' + currency}</div>)
        }
      },
    },
  ];
}

// Table fields specifically for 'archived students'
function getArchivedStudentFields() {
  let TabComponent = this;

  return [
    {
      name: "sName",
      title: __('Student', 'student', null, true),
      getTdProps: ({tbodyData})=>{
        return {
          className: "student-info",
        }
      },
      getTdContent: ({ trData: student })=>{
        return <StudentInfoTD studentInfo={student} />
      },
    },
  ];
}



// WEBPACK FOOTER //
// ./src/containers/pages/Student/student-table-field.js